<script>
import Vue from "vue";
import VTooltip from "v-tooltip";

Vue.use(VTooltip);
import Api from "@/helpers/apibtoast";
import Sabit from "@/helpers/apigeneric";
import StrPerfRaporGiris from "@/models/StrPerfRaporGiris";

import "v-tooltip/dist/v-tooltip.css";

export default {
  mixins: [Api, Sabit, StrPerfRaporGiris],
  props: ["UstDonemId", "DonemId", "Sorgulama","BirimId"],
  data() {
    return {
      Page: {
        PageNumber: "1",
        PageSize: "9999",
        PageDataSize: "1",
      },
      TabloVerileri: [],
      TabloDetayVerileri: [],
   
      Veriler: [],
      FormData: [],
      AltDonemler: [],
      gostergelistesi:[],
      deger: "",
      aciklama: "",
      bugun: null,
      uri: "data:application/vnd.ms-excel;base64,",
      template:
        '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--> <meta charset="utf-8"></head><body><table>{table}</table></body></html>',
      base64: function (s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },
      format: function (s, c) {
        return s.replace(/{(\w+)}/g, function (m, p) {
          return c[p];
        });
      },
    };
  },

  watch: {
    Sorgulama() {
      this.Get();
    },
  },

  methods: {



    Get() {
      this.bugun = new Date();

      this.TabloVerileri = [];
      this.TabloDetayVerileri = [];
      let Filter = ""
        if(this.BirimId != null && this.BirimId != ""){
        Filter += "&BirimId=" + this.BirimId
        }

      Filter += "&StrUstDonemId=" + this.UstDonemId + "&StrDonemId=" + this.DonemId;
      console.log(Filter)

      this.ActionsFilterGet({ Service: "StrRaporlama/GetOnaySayisi", Page: this.Page, Filter: Filter }).then((res) => {
        this.TabloVerileri = res.Data;
        this.Page.PageDataSize = res.TotalCount;


      });

    },

        ExcelExport(table, name){  
           
                if (!table.nodeType) table = this.$refs.hatasayilari;
                var html =table.innerHTML  
                var ctx = {worksheet: name || 'Worksheet', table:html }
                var a = document.createElement('a');
                a.href = this.uri +this.base64(this.format(this.template, ctx));
                a.download = name + '.xls';
                a.click();  
        
  
      }, 




  },
  computed: {},

  created() {
    this.Get();
  },
};
</script>
<template>
  <div>

        <div class="text-sm-end">
            <button
              type="button"
              class="btn btn-success btn-rounded mb-2 me-2"
              @click="
                ExcelExport(
                  'Hata Sayıları',
                  'Hata Sayıları',
                )
              "
            >
              <i class="mdi mdi-file-export-outline me-1"></i>
              Excel'e Aktar
            </button>
        </div>

  
    <div ref="hatasayilari" class="table-responsive">

    
      <table class="table table-striped table-bordered mb-0">
        <tbody>
          <tr>
            <td>

              <div class="table-responsive">
                <table class="table table-striped table-bordered mb-0">
                    <thead class="table-light">
                        <tr   style="background-color:rgb(7, 156, 165); vertical-align: top; text-align: center; ">
                            <th colspan="3">
                                {{ TabloVerileri[0].Donem }}
                            </th>
                        </tr>
                    </thead>


                </table>
                <table class="table table-striped table-bordered mb-0">
                  <thead class="table-light">
                    <tr>
                     <th colspan="1" style="background-color:rgb(7, 156, 165); vertical-align: top; text-align: center; ">
                        Birim
                      </th>
                      <th colspan="1" style="background-color:rgb(7, 156, 165); vertical-align: top; text-align: center; ">
                        İlk Onay Tarihi
                      </th>
                      <th colspan="1" style="background-color:rgb(7, 156, 165); vertical-align: top; text-align: center; ">
                        İlk Onaydan Sonra Yapılan Düzeltme Sayısı
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(TabloDetay, index) in TabloVerileri" :key="index">
                      <td>{{ TabloDetay.Birim }}</td>

                      <td scope="col" style="text-align: center; " v-if="TabloDetay.Onaysayisi != 0">{{ TabloDetay.Ilkonaytarihi | formatDateTable }}</td>
                      <td style="text-align: center; " v-else>Onaylanmamış</td>
                      <td style="text-align: center; " v-if="TabloDetay.Onaysayisi > 0">{{ TabloDetay.Onaysayisi - 1 }}</td>
                      <td style="text-align: center; " v-else>{{ TabloDetay.Onaysayisi }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <br />
    </div>
  </div>
</template>
